// Unknown or missing types fall back to the vehicle each screen usually loads
// (truck with trailer for fojas, van for repartos).
export function resolveVehicleShape(tipo, fallback = 'camion') {
  const normalized = String(tipo || '').toLowerCase();
  if (normalized === 'moto') return 'moto';
  if (normalized === 'utilitario' || normalized === 'auto') return 'utilitario';
  if (normalized === 'semi') return 'semi';
  if (normalized === 'acoplado') return 'acoplado';
  if (normalized === 'camion') return 'camion';
  return fallback;
}

export function computeCargoBoxes(ratio, totalBoxes, maxOverflow = 0) {
  const safeRatio = Math.max(Number(ratio) || 0, 0);
  if (safeRatio === 0 || totalBoxes <= 0) return { filled: 0, overflow: 0 };
  const filled = Math.min(Math.max(Math.round(safeRatio * totalBoxes), 1), totalBoxes);
  const extra = safeRatio > 1 ? Math.max(Math.round((safeRatio - 1) * totalBoxes), 1) : 0;
  return { filled, overflow: Math.min(extra, maxOverflow) };
}

export function computeVehicleLoad(unidad, totals) {
  const capacityM3 = Number(unidad?.capacidad_m3 ?? unidad?.capacidadM3 ?? 0) || 0;
  const capacityKg = Number(unidad?.capacidad_kg ?? unidad?.capacidadKg ?? 0) || 0;
  const usedM3 = Number(totals?.m3 || 0);
  const usedKg = Number(totals?.kilos || 0);
  const m3Ratio = capacityM3 > 0 ? usedM3 / capacityM3 : null;
  const kgRatio = capacityKg > 0 ? usedKg / capacityKg : null;
  const ratios = [m3Ratio, kgRatio].filter((value) => value != null);
  const ratio = ratios.length ? Math.max(...ratios) : 0;
  return {
    capacityM3,
    capacityKg,
    usedM3,
    usedKg,
    availableM3: capacityM3 > 0 ? capacityM3 - usedM3 : null,
    availableKg: capacityKg > 0 ? capacityKg - usedKg : null,
    m3Ratio,
    kgRatio,
    ratio,
    hasCapacity: ratios.length > 0,
    overloaded: ratio > 1,
  };
}

const formatExcess = (value, digits) =>
  new Intl.NumberFormat('es-AR', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value);

export function buildOverloadMessage(load) {
  if (!load?.overloaded) return null;
  const parts = [];
  if (load.availableM3 != null && load.availableM3 < 0) parts.push(`${formatExcess(-load.availableM3, 2)} m³`);
  if (load.availableKg != null && load.availableKg < 0) parts.push(`${formatExcess(-load.availableKg, 0)} kg`);
  return `Hay ${parts.join(' y ')} de más (${Math.round(load.ratio * 100)}% de la unidad). Podés sacar guías o seguir igual si la política lo permite.`;
}
